import React, { useState, useContext, createRef } from 'react';
import CustomLoader from '../../components/loader/customLoader';
import Navbar from '../../components/navbar';
import './style.scss';
import { Context } from '../../store';
import CustomSnackbar from '../../components/snack';
import axios from 'axios';
import LockIcon from '@material-ui/icons/Lock';
import BlockIcon from '@material-ui/icons/Block';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { BACKURL } from '../../components/network';

const Settings = (props) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const { state } = useContext(Context);

  const [openSecret, setopenSecret] = useState(false);
  const [openChanger, setopenChanger] = useState(false);

  const code = createRef();
  const pass = createRef();
  const repass = createRef();
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const ForgetPassword = async () => {
    setLoading(true);
    const data = await axios.post(`${BACKURL}/forgetpassword`, {
      email: state.email,
    });
    setLoading(false);
    if (data.data.done) {
      setMsg(data.data.msg);
      setOpen(true);
      setopenSecret(true);
      return;
    }
    setMsg(data.data.msg);
    setOpen(true);
    return;
  };
  const ConfirmCode = async () => {
    if (!code.current.value) {
      setMsg('Code is Empty!');
      setOpen(true);
      return;
    }
    setLoading(true);
    const data = await axios.post(
      'https://peaceful-lowlands-57595.herokuapp.com/check-code',
      { email: state.email, code: code.current.value },
    );
    setLoading(false);
    if (data.data.done) {
      setopenSecret(false);
      setMsg(data.data.msg);
      setOpen(true);
      setopenSecret(false);
      setopenChanger(true);
      return;
    }
    setMsg(data.data.msg || 'Error');
    setOpen(true);
    return;
  };
  const Deactivate = async () => {
    setLoading(true);
    const data = await axios.post(
      'https://peaceful-lowlands-57595.herokuapp.com/deactivate',
      { email: state.email },
    );
    setLoading(false);
    if (data.data.done) {
      setMsg(data.data.msg);
      setOpen(true);
      props.history.push('/');
      return;
    }
    setMsg(data.data.msg);
    setOpen(true);
    return;
  };
  const Reset = async () => {
    if (pass.current.value !== repass.current.value) {
      setMsg('Passwords didnt match!');
      setOpen(true);
      return;
    }
    setLoading(true);
    const data = await axios.post(
      'https://peaceful-lowlands-57595.herokuapp.com/reset/23w4erd6ftycygvyhubhin0on',
      {
        email: state.email,
        code: code.current.value,
        password: pass.current.value,
      },
    );
    setLoading(false);
    if (data.data.done) {
      setopenSecret(false);
      setMsg(data.data.msg);
      setOpen(true);
      setopenChanger(false);
      return;
    }
    setMsg(data.data.msg);
    setOpen(true);
    return;
  };
  return (
    <>
      {loading ? <CustomLoader /> : null}
      <div className='settings-wrapper'>
        <Navbar props={props} />
        <div className='settings-container'>
          <div className='title'>Settings</div>
          <button onClick={ForgetPassword}>
            <div>
              <LockIcon />
              <span>Change Password</span>
            </div>
          </button>
          <button onClick={Deactivate}>
            <div>
              <BlockIcon />
              <span>Deactive Account</span>
            </div>
          </button>
          <button
            onClick={() => props.history.push('/main')}
            className='settings-back'>
            Back
          </button>
        </div>
        <CustomSnackbar open={open} handleClose={handleClose} msg={msg} />
      </div>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: '#222',

            color: 'white',
          },
        }}
        open={openSecret}
        keepMounted
        onClose={() => setopenSecret(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogTitle
          id='alert-dialog-slide-title'
          style={{
            textAlign: 'center',
          }}>
          Enter Your Secret Code:
        </DialogTitle>
        <div className='dialog-child'>
          <input maxLength='6' ref={code} />
        </div>
        <DialogActions>
          <Button onClick={ConfirmCode} color='inherit'>
            Submit
          </Button>
          <Button onClick={() => setopenSecret(false)} color='inherit'>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: '#222',

            color: 'white',
          },
        }}
        open={openChanger}
        keepMounted
        onClose={() => setopenChanger(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogTitle
          id='alert-dialog-slide-title'
          style={{
            textAlign: 'center',
          }}>
          Enter New Password:
        </DialogTitle>
        <div className='dialog-child'>
          <input
            type='password'
            minLength='6'
            ref={pass}
            placeholder='New Password'
          />
          <input
            type='password'
            minLength='6'
            ref={repass}
            placeholder='Re-Enter Password'
          />
        </div>
        <DialogActions>
          <Button onClick={Reset} color='inherit'>
            Change
          </Button>
          <Button onClick={() => setopenChanger(false)} color='inherit'>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Settings;
